module.exports = __webpack_public_path__ + "media/assault2.1b6438fb.webm";